// extracted by mini-css-extract-plugin
module.exports = {"whatsAppBtn":"WhatsAppBtn_whatsAppBtn__bMmP9","isFixed":"WhatsAppBtn_isFixed__Mv_LQ"};